(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name consult.directive:examsummaries
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="consult">
       <file name="index.html">
        <examsummaries consult=""></examsummaries>
       </file>
     </example>
   *
   */
  angular
    .module('consult')
    .directive('examsummaries', examsummaries);

  function examsummaries() {
    return {
      restrict: 'EA',
      scope: {
        consult: '='
      },
      templateUrl: 'consult/examsummaries-directive.tpl.html',
      replace: false,
      controllerAs: 'esCtrl',
      bindToController: true,
      controller: function () {
        var vm = this;
        vm.name = 'examsummaries';

        vm.popover = 'examsummaries_popver.tpl.html';
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
